const cFormEn = {
  attributeRenderer: {
    noAttributes: "No attributes",
  },
};

export default cFormEn;
